import React, { Suspense, lazy } from 'react';
import Fallback from '../Fallback';

const DashboardEngagementChart = lazy(() =>
  import('../../components/dashboard/DashboardEngagementChart')
);

export default function LazyDashboardEngagementChart({__placeholder_html__, ...props}) {
  return (
    <Suspense
      fallback={<Fallback __placeholder_html__={__placeholder_html__} />}
    >
      <DashboardEngagementChart {...props} />
    </Suspense>
  );
}
